import type { DutyRow, OrgRow } from '../utils'
import type { TabKey } from './model'

/**
 * Which tab shows and what it has drilled into, as one value. A drill-in is a
 * field of its tab's arm, so switching tabs drops it by construction. Compare
 * is the Content tab's own drill-in.
 */
export type SheetView =
  | { tab: 'content'; compare: boolean }
  | { tab: 'variants'; open: DutyRow | null }
  | { tab: 'orgs'; open: OrgRow | null }

export const CONTENT_VIEW: SheetView = { tab: 'content', compare: false }

export function viewForTab(tab: TabKey): SheetView {
  return tab === 'content' ? CONTENT_VIEW : { tab, open: null }
}

/** A view whose tab the kind no longer has (sharing switched off) shows Content. */
export function resolveView(
  view: SheetView,
  tabs: readonly TabKey[]
): SheetView {
  return tabs.includes(view.tab) ? view : CONTENT_VIEW
}

/** One step back, for Back and Escape. Null at a tab's root. */
export function backOf(view: SheetView): SheetView | null {
  if (view.tab === 'content') return view.compare ? CONTENT_VIEW : null
  return view.open ? { tab: view.tab, open: null } : null
}
